export default {
  path: 'aggregator/road-information',
  name: 'Aggregator_road_information',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/AggregatorRoadInformationMain.vue')
}
